import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const payoutStatementSettings = {
  stateName: 'payoutStatement',
  dataType: 'object',
  actions: {
    create: 'ducks/payouts/CREATE_PAYOUT_STATEMENT',
  },
};

// Action Creators
export function createPayoutStatement(
  values,
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    payoutStatementSettings.actions.create,
    'post',
    `${API_URL}/practice/payout_statements`,
    { ...values },
    true,
    callback,
    errorCallback,
  );
}
